(function () {
    // Opening hours configuration for pickup locations
    // Format: "Location Name": { day: { open: "HH:MM", close: "HH:MM" } }
    const openingHours = {
        // TODO: Update these with actual location names and opening hours
        'MEDIAMARKT LUXEMBOURG CITY': {
            monday: { open: '10:00', close: '19:00' },
            tuesday: { open: '10:00', close: '19:00' },
            wednesday: { open: '10:00', close: '19:00' },
            thursday: { open: '10:00', close: '19:00' },
            friday: { open: '10:00', close: '19:00' },
            saturday: { open: '10:00', close: '19:00' },
            sunday: { open: '', close: '' },
        },
        'MEDIAMARKT BELVAL': {
            monday: { open: '10:00', close: '20:00' },
            tuesday: { open: '10:00', close: '20:00' },
            wednesday: { open: '10:00', close: '20:00' },
            thursday: { open: '10:00', close: '20:00' },
            friday: { open: '10:00', close: '20:00' },
            saturday: { open: '09:00', close: '19:00' },
            sunday: { open: '12:00', close: '18:00' },
        },
    };

    // Helper function to parse time string "HH:MM" to minutes since midnight
    function timeToMinutes(timeString) {
        const [hours, minutes] = timeString.split(':').map(Number);
        return hours * 60 + minutes;
    }

    // Helper function to format minutes to "HH:MM"
    function minutesToTime(minutes) {
        const hours = Math.floor(minutes / 60);
        const mins = minutes % 60;
        return (
            hours.toString().padStart(2, '0') +
            ':' +
            mins.toString().padStart(2, '0')
        );
    }

    // Get day name from date
    function getDayName(date) {
        const days = [
            'sunday',
            'monday',
            'tuesday',
            'wednesday',
            'thursday',
            'friday',
            'saturday',
        ];
        return days[date.getDay()];
    }

    // Check if store is currently open
    function isStoreOpen(locationName, currentTime) {
        const hours = openingHours[locationName];
        if (!hours) return true; // If no hours defined, assume always open

        const dayName = getDayName(currentTime);
        const dayHours = hours[dayName];
        if (!dayHours) return false;

        const currentMinutes =
            currentTime.getHours() * 60 + currentTime.getMinutes();
        const openMinutes = timeToMinutes(dayHours.open);
        const closeMinutes = timeToMinutes(dayHours.close);

        return currentMinutes >= openMinutes && currentMinutes < closeMinutes;
    }

    // Calculate next available pickup time
    function calculatePickupTime(locationName, currentTime) {
        const hours = openingHours[locationName];
        if (!hours) {
            // No hours defined, return current time + 30 minutes
            const pickupTime = new Date(currentTime);
            pickupTime.setMinutes(pickupTime.getMinutes() + 30);
            return pickupTime;
        }

        const dayName = getDayName(currentTime);
        const dayHours = hours[dayName];

        if (!dayHours) {
            // Store closed today, find next open day
            return findNextOpenTime(locationName, currentTime);
        }

        const currentMinutes =
            currentTime.getHours() * 60 + currentTime.getMinutes();
        const openMinutes = timeToMinutes(dayHours.open);
        const closeMinutes = timeToMinutes(dayHours.close);
        const pickupMinutes = currentMinutes + 30;

        // If pickup time is within today's opening hours
        if (pickupMinutes < closeMinutes && currentMinutes >= openMinutes) {
            const pickupTime = new Date(currentTime);
            pickupTime.setMinutes(pickupTime.getMinutes() + 30);
            return pickupTime;
        }

        // If store is closed or pickup would be after closing, find next available time
        if (currentMinutes < openMinutes) {
            // Store opens later today
            const pickupTime = new Date(currentTime);
            pickupTime.setHours(Math.floor(openMinutes / 60), openMinutes % 60);
            pickupTime.setMinutes(pickupTime.getMinutes() + 30);
            return pickupTime;
        } else {
            // Store closed for today, find next open day
            return findNextOpenTime(locationName, currentTime);
        }
    }

    // Find next open time (next day)
    function findNextOpenTime(locationName, currentTime) {
        const hours = openingHours[locationName];
        if (!hours) {
            const pickupTime = new Date(currentTime);
            pickupTime.setDate(pickupTime.getDate() + 1);
            pickupTime.setHours(9, 0);
            return pickupTime;
        }

        // Check next 7 days
        for (let i = 1; i <= 7; i++) {
            const checkDate = new Date(currentTime);
            checkDate.setDate(checkDate.getDate() + i);
            const dayName = getDayName(checkDate);
            const dayHours = hours[dayName];

            if (dayHours) {
                const openMinutes = timeToMinutes(dayHours.open);
                const pickupTime = new Date(checkDate);
                pickupTime.setHours(Math.floor(openMinutes / 60), openMinutes % 60);
                pickupTime.setMinutes(pickupTime.getMinutes() + 30);
                return pickupTime;
            }
        }

        // Fallback: tomorrow at 10:30
        const pickupTime = new Date(currentTime);
        pickupTime.setDate(pickupTime.getDate() + 1);
        pickupTime.setHours(10, 30);
        return pickupTime;
    }

    // Process each pickup location
    const now = new Date();
    const storeElements = document.querySelectorAll(
        '.product__availability-store[data-location-name]'
    );

    storeElements.forEach(function (storeEl) {
        const locationName = storeEl.getAttribute('data-location-name');
        const pickupTimeEl = storeEl.querySelector(
            '.pickup-time-calculated[data-location-name="' + locationName + '"]'
        );

        if (!pickupTimeEl) return;

        // Check if store is currently open
        const isOpen = isStoreOpen(locationName, now);

        if (!isOpen) {
            // Store is closed, calculate next available pickup time
            const nextPickupTime = calculatePickupTime(locationName, now);
            const hours = nextPickupTime.getHours().toString().padStart(2, '0');
            const minutes = nextPickupTime.getMinutes().toString().padStart(2, '0');
            pickupTimeEl.textContent = hours + ':' + minutes;

            // Optionally update parent text to indicate it's for next available time
            const parentText = pickupTimeEl.parentElement;
            if (
                parentText &&
                parentText.textContent.includes('Commande maintenant')
            ) {
                // Could update text here if needed
            }
        } else {
            // Store is open, calculate pickup time (current + 30 min)
            const pickupTime = calculatePickupTime(locationName, now);
            const hours = pickupTime.getHours().toString().padStart(2, '0');
            const minutes = pickupTime.getMinutes().toString().padStart(2, '0');
            pickupTimeEl.textContent = hours + ':' + minutes;
        }
    });
})();